import React from 'react';
import { findDOMNode } from 'react-dom';
import autobind from 'autobind-decorator';
import Base from 'client/components/base';
import ChannelList from 'client/components/common/channel-list';
import AcastList from 'client/components/common/acast-list';
import Loader from 'client/components/common/loader';
import StringStore from 'client/stores/strings';
import RouteStore from 'client/stores/route';
import Router from 'react-router';
import { Query } from 'acast-reactor';

const MOBILE_SCREEN = 750;

@Query.inject(props => {
  return {
    searchResults: Query.run('GetSearchResults', props.query),
  };
})
export default class Search extends Base {
  constructor() {
    super();

    this.state = {
      showResult: false,
      screenWidth: 300,
      error: null,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();

    RouteStore.addWillLeaveListener(this.onWillLeave);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    RouteStore.removeWillLeaveListener(this.onWillLeave);
  }

  @autobind
  onWillLeave() {
    this.setState({
      showResult: false,
    });
  }

  @autobind
  onResize() {
    let DOMNode = findDOMNode(this.refs.searchcontainer);
    this.setState({
      screenWidth: DOMNode.getBoundingClientRect().width,
    });
  }

  componentWillReceiveProps(newProps) {
    if (this.propsDidChange(newProps)) {
      if (newProps.query === '') {
        this.props.onSearchEnd &&
          this.props.onSearchEnd({ value: newProps.query });

        this.setState({
          showResult: false,
        });
        return;
      }
      if (!newProps.searchResults.isComplete) {
        newProps.onSearchStart &&
          newProps.onSearchStart({ value: newProps.query });
        this.setState({
          searchResults: undefined,
          showResult: false,
        });
      } else if (newProps.query && newProps.searchResults.isComplete) {
        this.props.onSearchEnd &&
          this.props.onSearchEnd({ value: newProps.query });

        this.setState({
          searchResults: newProps.searchResults.value,
          showResult: true,
        });
      } else if (newProps.searchResults.error) {
        this.setState({
          error: newProps.searchResults.error,
          showResult: false,
        });
      }
    }
  }

  render() {
    if (this.state.error) {
      return (
        <div ref="searchcontainer" className={this.css()}>
          <section>
            <div className="content error">
              {StringStore.get('common.errors.search')}
            </div>
          </section>
        </div>
      );
    } else if (this.state.showResult && this.state.searchResults) {
      let channels = (
        <div className="noresult">{StringStore.get('common.noResults')}</div>
      );
      if (this.state.searchResults.channels.length) {
        let itemWidth;
        let itemHeight;
        if (this.state.screenWidth > MOBILE_SCREEN) {
          itemWidth = 245;
          itemHeight = 280;
        } else {
          itemWidth = 130;
          itemHeight = 160;
        }

        channels = (
          <ChannelList
            channels={this.state.searchResults.channels}
            numberOfCols={5}
            numberOfRows={2}
            itemWidth={itemWidth}
            itemHeight={itemHeight}
          />
        );
      }

      let acasts = (
        <div className="noresult">{StringStore.get('common.noResults')}</div>
      );
      if (this.state.searchResults.acasts.length) {
        acasts = (
          <AcastList
            numberPerCol="2"
            numberOfCols="2"
            acasts={this.state.searchResults.acasts.slice(0, 4)}
          />
        );
      }

      return (
        <div ref="searchcontainer" className={this.css()}>
          <div className="shows">
            <h3>{StringStore.get('common.shows')}</h3>
            {channels}
          </div>
          <div className="episodes">
            <h3>{StringStore.get('common.episodes')}</h3>
            {acasts}
          </div>
        </div>
      );
    } else {
      return <div ref="searchcontainer" className={this.css()} />;
    }
  }
}



// WEBPACK FOOTER //
// ./client/components/common/search/search.es6